import { schemes, zSchema } from "@zeal/common";

export const listCheckbookChecksRequestSchema = zSchema.object({
  type: zSchema.enum(["digital", "physical"]).optional(),
  page: zSchema.number().int().positive().optional(),
  per_page: zSchema.number().int().positive().max(100).optional(),
  status: zSchema.string().optional(),
  companyId: schemes.companyID(),
  employeeId: zSchema.string().optional(),
  dateFrom: zSchema.string().optional(),
  dateTo: zSchema.string().optional(),
});

export type TListCheckbookChecksRequest = zSchema.infer<
  typeof listCheckbookChecksRequestSchema
>;

const checkbookPaymentSchema = zSchema.object({
  account: zSchema.string().nullish(),
  amount: zSchema.number(),
  comment: zSchema.string().nullish(),
  date: zSchema.string().nullish(),
  description: zSchema.string().nullish(),
  id: zSchema.string(),
  image_uri: zSchema.string().nullish(),
  name: zSchema.string().nullish(),
  number: zSchema.number(),
  recipient: zSchema
    .union([
      zSchema.string(),
      zSchema.record(zSchema.string(), zSchema.unknown()),
    ])
    .nullish(),
  remittance_advice: zSchema.array(zSchema.unknown()).nullish(),
  status: zSchema.string(),
});

export type TCheckbookPayment = zSchema.infer<typeof checkbookPaymentSchema>;

export const listCheckbookChecksRowSchema = zSchema.object({
  paystub_id: zSchema.string(),
  employeeID: zSchema.string(),
  companyID: zSchema.string(),
  check_date: zSchema.string(),
  net_pay: zSchema.number(),
  first_name: zSchema.string(),
  last_name: zSchema.string(),
  disbursement_method: zSchema.string(),
  checkbook_checkId: zSchema.string(),
  checkbook: checkbookPaymentSchema.nullable(),
  address: zSchema.string().nullable(),
  debit_account: zSchema.string().nullable(),
  sender_name: zSchema.string().nullable(),
  error: zSchema.string().optional(),
});

export type TListCheckbookChecksRow = zSchema.infer<
  typeof listCheckbookChecksRowSchema
>;

export const listCheckbookChecksResponseSchema = zSchema.object({
  page: zSchema.number(),
  per_page: zSchema.number(),
  total: zSchema.number(),
  rows: zSchema.array(listCheckbookChecksRowSchema),
});

export type TListCheckbookChecksResponse = zSchema.infer<
  typeof listCheckbookChecksResponseSchema
>;
